import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import { Link } from 'gatsby'
import React, { memo } from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

export interface Props {
  image?: ImageProps
  title?: string
  URL: string
}

export const Item = memo(function Item({ image, title, URL }: Props) {
  if (!URL) {
    return null
  }

  return (
    <Container to={URL}>
      {image ? (
        <LazyLoadComponent>
          <Image {...image} />
        </LazyLoadComponent>
      ) : null}
      {title ? <Title>{title}</Title> : null}
    </Container>
  )
})

const Container = styled(Link)`
  width: calc(50% - 1.875rem);
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  overflow: hidden;
  margin-right: 1.875rem;
  padding-bottom: 17.2%;
  position: relative;
  &:hover {
    &:before {
      opacity: 1;
    }
    img {
      transform: scale(1.1);
    }
    > div {
      bottom: 2.125rem;
    }
  }
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    background: linear-gradient(
      ${rgba(theme.colors.variants.fadeDark, 0)},
      ${rgba(theme.colors.variants.fadeDark, 1)}
    );
    opacity: 0.9;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.25s ease-in-out;
    z-index: 1;
  }

  img {
    width: 101%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.25s ease-in-out;
  }

  @media (max-width: 1199px) {
    width: calc(50% - 1.5rem);
    margin-right: 1.5rem;
    padding-bottom: 20%;
  }

  @media (max-width: 1023px) {
    width: 100%;
    margin: 0.75rem 0 0;
    padding-bottom: 25%;
  }

  @media (max-width: 767px) {
    padding-bottom: 50%;
  }
`

const Title = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.875rem;
  padding-left: 3rem;
  position: absolute;
  bottom: 1.375rem;
  right: 1.875rem;
  left: 1.875rem;
  transition: 0.25s ease-in-out;
  z-index: 2;
  &:before {
    content: '';
    width: 2rem;
    height: 0.0625rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight4};
    position: absolute;
    top: 0.875rem;
    left: 0;
  }
`
